import { FC, useEffect, useState } from "react";
import styles from "./Header.module.scss";
import { routesAuth, routesNoAuth } from "./constant";
import logo from "../../../images/logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES, RouteValues } from "../../../helpers/routes";
import { useAppDispatch, useAppSelector } from "../../../services/hooks";
import { logout } from "../../../services/slices/user";
import logoutIcon from "../../../images/header/login.svg";

export const Header: FC = () => {
  const { user, loading } = useAppSelector((state) => state.user);
  const router = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [routes, setRoutes] = useState<
    Array<{
      name: string;
      icon?: string;
      path: RouteValues;
    }>
  >([]);

  useEffect(() => {
    if (!loading) {
      if (user) {
        setRoutes(routesAuth);
      } else {
        setRoutes(routesNoAuth);
      }
    }
  }, [user, loading]);

  const handleLogout = () => {
    dispatch(logout());
    navigate(ROUTES.home);
    setRoutes(routesNoAuth);
  };

  const isHidden =
    router.pathname === ROUTES.login ||
    router.pathname === ROUTES.register ||
    router.pathname === ROUTES.setPassword ||
    router.pathname.includes(ROUTES.forgotPassword);

  return (
    <>
      <header className={`${styles.header} ${isHidden && styles.header_block}`}>
        <nav className={styles.nav}>
          <a href="/">
            <img className={styles.logo} src={logo} alt="Логотип" />
          </a>

          {loading ? (
            <div className={styles.loader}>
              <div className={styles.loader_dots}>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
              </div>
            </div>
          ) : (
            <>
              <ul className={styles.routes}>
                {routes.map((item, index) => (
                  <li className={styles.routes_item} key={index}>
                    <a
                      href={item.path}
                      className={`${styles.link} ${
                        router.pathname === item.path && styles.link_active
                      }`}
                    >
                      {item.icon && (
                        <img
                          src={item.icon}
                          alt="Icon"
                          className={styles.icon}
                        />
                      )}
                      {item.name}
                    </a>
                  </li>
                ))}
                {user && (
                  <li className={styles.routes_item}>
                    <button className={styles.logout} onClick={handleLogout}>
                      <img
                        src={logoutIcon}
                        alt="Icon"
                        className={styles.icon}
                      />
                      Logout
                    </button>
                  </li>
                )}
              </ul>
              <input
                type="checkbox"
                id="burger-checkbox"
                className={styles.burgerСheckbox}
                checked={openMenu}
                onClick={() => setOpenMenu(!openMenu)}
              />
              <label
                className={styles.burger}
                htmlFor="burger-checkbox"
              ></label>
            </>
          )}
        </nav>
      </header>

      {!loading && (
        <ul className={`${styles.menu_routes} ${openMenu && styles.open}`}>
          {routes.map((item, index) => (
            <li className={styles.menu_routes_item} key={index}>
              <a
                href={item.path}
                className={styles.menu_link}
                onClick={() => setOpenMenu(false)}
              >
                {item.name}
              </a>
            </li>
          ))}
          {user && (
            <li className={styles.menu_routes_item}>
              <button
                className={styles.menu_logout_button}
                onClick={handleLogout}
              >
                Logout
              </button>
            </li>
          )}
        </ul>
      )}
    </>
  );
};
